import React from "react";
import "./styles.css";

const MpButtonPrimary = ({ CTA_TEXT, onCtaClick, customStyle }) => {
  return <div className="mp-primary-button" style={customStyle} onClick={onCtaClick}>{CTA_TEXT}</div>;
};

export default MpButtonPrimary;
